import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./LoginSlice";


const store = configureStore({

        reducer: {
                loginReducer: loginReducer,
        },
});

export default store;